import React from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@nextui-org/react";
import Header from "./Header";
import {DocUploadErrorIcon} from "../icons/DocUploadErrorIcon";
import PoweredBy from "./PoweredBy";

function UploadError({title, desc, tryAgainFunc}) {
    const {t} = useTranslation();
    return (
        <div className="flex flex-col gap-4 w-full h-full">
            <Header/>
            <div className="flex flex-col gap-4 w-full p-4  h-full justify-between">
                <div></div>
                <div className="flex flex-col items-center justify-center">
                    <DocUploadErrorIcon/>
                    <div className="mb-5 text-center">
                        <div className="font-normal text-xl" style={{color: "var(--urtentic-sdk-title, #000000)"}}>{title}</div>
                        <div className="text-sm pr-7 pl-7 pt-2" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>
                            {desc}
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <Button radius="sm" color="primary" className="w-full" onClick={() => tryAgainFunc()}>{t("common.uploadError.tryAgain")}</Button>
                    <div className="flex-row flex justify-center mt-3">
                        <PoweredBy/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UploadError;
